import type { NotificationProps } from '../notification'

import { useNavigate } from 'react-router-dom'

import { Notification } from '../notification'

export interface IneligiblePatientNotificationProps extends NotificationProps {
  id: string
  clientName: string
  patientId: string
  firstName: string
  lastName: string
}

export function IneligiblePatientNotification ({
  clientName,
  patientId,
  firstName,
  lastName,
  ...rest
}: IneligiblePatientNotificationProps): JSX.Element {
  let navigate = useNavigate()

  return (
    <Notification
      title='Ineligible Patient'
      date={rest.date ?? new Date()}
      onClick={() => {
        navigate(`/patient/${clientName}/${patientId}/patientFolder`)
        rest.onDismiss()
      }}
      {...rest}
    >
      {firstName} {lastName} is no longer eligible
    </Notification>
  )
}
